<template>
  <div class="change_terminal_block col-lg-6 col-md-8 col-12">
    <div v-if="$helper.trans('Change_terminal_top_message') !== '--'" class="text-danger text-center mt-2 mb-4">{{ $helper.trans('Change_terminal_top_message') }}</div>
    <div class="row">
      <div class="col-12">
        <label for="city" class="col-form-label">
          {{ $helper.trans('City') }}: *
        </label>
        <select v-model="form.city" id="city_select" type="text" class="input-big">
          <option v-for="(city, key) in cities" :value="key">{{ city }}</option>
        </select>
        <span v-if="errors.city" class="error-message">{{ errors.city[0] }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <label for="terminal" class="col-form-label">
          {{ $helper.trans('Terminal') }}: *
        </label>
        <select v-model="form.terminal" id="terminal_select" type="text" class="input-big" disabled>
          <optgroup v-for="(group, groupName) in terminals" :label="groupName">
          <option
              v-for="terminal in group"
              :value="terminal.id"
              :data-group="terminal.thumb"
          >{{ terminal.name }}</option>
          </optgroup>
        </select>
        <span v-if="errors.terminal" class="error-message">{{ errors.terminal[0] }}</span>
      </div>
    </div>
    <div v-show="form.terminal !== ''" class="text-center col-12 mt-4 mb-8">
      <ParcelControlOfficeWorkTime :work-time="workTime" :show-work-time="false"/>
    </div>
    <div v-show="form.terminal !== ''" class="row">
      <div class="col-12">
        <label for="change_terminal_datepicker" class="col-form-label">
          {{ $helper.trans('Desired_delivery_date') }}: *
        </label>
        <input
            v-model="form.new_date"
            id="change_terminal_datepicker"
            type="text"
            class="input-big"
            :data-custom-datepicker-settings="JSON.stringify(datepickerCustomSettings)"
            @change="(val) => form.new_date = val"
        >
        <span v-if="errors.new_date" class="error-message">{{ errors.new_date[0] }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <label class="col-form-label">
          {{ $helper.trans('Remarks') }}:
        </label>
        <textarea v-model="form.remarks" cols="50" rows="10"></textarea>
        <span v-if="errors.remarks" class="error-message">{{ errors.remarks[0] }}</span>
      </div>
    </div>
    <div v-if="$helper.trans('Change_terminal_bottom_message') !== '--'" class="text-danger text-center mt-2">{{ $helper.trans('Change_terminal_bottom_message') }}</div>

    <div class="text-center mt-2">
      <button type="button" class="btn btn-yellow" @click="saveData">{{ $helper.trans('Save') }}</button>
    </div>
  </div>
</template>

<script>
import ParcelControlOfficeWorkTime from "./ParcelControlOfficeWorkTime.vue";

export default {
  components: {ParcelControlOfficeWorkTime},
  data: function () {
    return {
      form: {
        terminal: '',
        city: '',
        new_date: '',
        remarks: '',
      },
      datepickerCustomSettings: {
        minDate: '',
        noWeekends: true,
      },
      cities: [],
      terminals: [],
      workTime: {},
    }
  },
  props: {
    holidays: {
      required: true,
      type: Array,
      default: [],
    },
    citiesUrl: {
      required: true,
      type: String,
    },
    terminalsUrl: {
      required: true,
      type: String,
    },
    workTimeUrl: {
      required: true,
      type: String,
    },
    errors: {
      type: Object,
      required: false,
      default: {},
    },
  },
  mounted: function () {
    this.fetchCities()
    this.fetchTerminals()
    const currentTime = moment().format('Hmm')
    if (currentTime > 930) {
      this.datepickerCustomSettings.minDate = moment().add(1, 'days').format('YYYY-MM-DD');
    } else {
      this.datepickerCustomSettings.minDate = moment().format('YYYY-MM-DD');
    }
    this.datepickerCustomSettings.holidays = this.holidays
    this.$nextTick(() => {
      $('#city_select').select2().on('select2:select', (e) => {
        const data = e.params.data

        let val = data.id

        const terminal_select = $('#terminal_select')

        terminal_select.val('')
        terminal_select.trigger('change')
        if (val !== '') {
          terminal_select.prop('disabled', false)
        } else {
          terminal_select.prop('disabled', 'disabled')
        }
        terminal_select.find('option').each(function (index, element) {
          if ($(element).data('group') === undefined || $(element).data('group') === val) {
            $(element).prop('disabled', false).trigger('change')
          } else {
            $(element).prop('disabled', 'disabled').trigger('change')
          }
        })

        $('#terminal_select optgroup').each(function (index, element) {
          let optgroup = $(element)
          if (optgroup.find('option').filter(function () {
            return !$(this).prop('disabled');
          }).length > 0) {
            optgroup.prop('disabled', false).trigger('change')
          } else {
            optgroup.prop('disabled', 'disabled').trigger('change')
          }
        })

        terminal_select.select2({
          templateResult: function (data) {
            // If the option is disabled, return null to exclude it
            if ($(data.element).is(':disabled')) {
              return null;
            }
            return data.text; // Default rendering
          }
        }).on('select2:select', (e) => {
          const data = e.params.data

          this.form.terminal = data.id || ''

          if (data.id) {
            axios.get(this.workTimeUrl, {
              params: {
                option: data.id,
              },
            }).then((res) => {
              this.workTime = res.data
            }).catch((e) => {
              console.error(e)
            });
          }
        })

        this.form.city = data.id || ''
      })

      const datepickerInput = $('#change_terminal_datepicker')
      window.initDatePicker(datepickerInput);
      datepickerInput.on('change', (event) => {
        let newDate = moment($(event.target).val())

        while (
            newDate.isoWeekday() >= 6
            || this.holidays.some((holidayDate) => {
              return moment(holidayDate).isSame(newDate, 'day');
            })
            ) {
          newDate.add(1, 'day');
        }

        this.form.new_date = newDate.format('YYYY-MM-DD')
      });
      window.initDatePicker(datepickerInput);
    })
  },
  methods: {
    fetchTerminals() {
      axios.get(this.terminalsUrl).then((res) => {
        this.terminals = res.data
      }).catch((e) => {
        console.error(e)
      });
    },
    fetchCities() {
      axios.get(this.citiesUrl).then((res) => {
        this.cities = res.data
      }).catch((e) => {
        console.error(e)
      });
    },
    saveData() {
      const data = {
        opened_box: 5,
        ...this.form,
      }

      this.$emit('save', data)
    },
  }
}
</script>
